module.exports = __webpack_public_path__ + "media/images/icons/icon-gradient-plus-85f9d9b671c704f51e7361cee6020fb5.png";